<template>
  <div id="graphique">
    <div
      style="
        position: fixed;
        z-index: 1;
        top: 60px;
        right: 0;
        left: 60px;
        background-color: white;
        box-shadow: 0 0 3px 0 #ccc;
      "
    >
      <div id="graphique_area">
        <MainMenu
          v-if="!first_load"
          @get-client-stat="getClientStat"
          @get-params="getParams"
          @get-export-data="getExportData"
          :timestamp="timestamp"
          :params="selectedParams"
          :graphsMenu="params"
          :menu="json_menu"
          :info="json_info"
        />
      </div>
    </div>

    <Stats
      v-if="timestamp && isStat && !changeGraph"
      @get-client-stat="getClientStat"
      :loading="loading"
      :timestamp="timestamp"
      :params="selectedParams"
      :action="action"
      :json_data="json_data"
      :category="selectedParams.category"
    />

    <Export
      v-if="timestamp && isExport"
      :timestamp="timestamp"
      :params="selectedParams"
      :summary="exportSummary"
      :json_data="json_data"
    />
  </div>
</template>

<script>
import MainMenu from "../components/newGraphique/MainMenu.vue";
import Stats from "../components/newGraphique/Stats.vue";
import Export from "../components/newGraphique/Export/index.vue";

import { message } from "ant-design-vue";

export default {
  name: "portefeuille",
  components: {
    MainMenu,
    Stats,
    Export,
  },
  data: function () {
    return {
      params: {
        graph: "sin",
      },
      selectedParams: null,
      exportSummary: {},

      changeGraph: false,
      first_load: true,

      json_menu: {},
      json_data: {},
      json_info: {},
      timestamp: 0,
      action: null,

      loading: true,
      paramsLoaded: true,
      dataLoaded: true,
    };
  },
  watch: {
    graph() {
      this.changeGraph = true;
      this.getClientStat();
    },
  },
  methods: {
    getExportData() {
      this.$axios
        .post(
          `/data/generate/graphique/${this.type}/${
            this.num
          }/?${new URLSearchParams(this.selectedParams)}`
        )
        .then((r) => {
          if (r.status === 200) {
            this.json_menu = r.data.menu;
            this.timestamp = r.data.timestamp;
          }
        })
        .catch((error) => {
          message.warning(error.response.data.error_message);
        })
        .finally((_) => {
          setTimeout(() => {
            this.first_load = false;
            this.changeGraph = false;
            this.loading = false;
          }, 100);
        });
    },
    getParams() {
      if(this.num === undefined){
        return
      }

      this.loading = true;
      this.timestamp = 0;
      this.$axios
        .get(`/data/company/stat/${this.type}/${this.num}/params`)
        .then((r) => {
          if (r.status === 200) {
            this.params = r.data.params;
            this.json_info = r.data.info;
            this.selectedParams = this.params.find(
              (p) => p.graph == this.graph
            );

            this.getClientStat();
          }
        });
    },
    getClientStat(action = "load") {
      message.destroy();

      if(this.num === undefined){
        return
      }

      const params = this.params.find((p) => p.graph == this.graph);

      this.selectedParams = params;

      this.loading = true;
      this.$axios
        .get(
          `/data/company/stat/${this.type}/${this.num}/?${new URLSearchParams(
            this.selectedParams
          )}`
        )
        .then((r) => {
          if (r.status === 200) {
            if(this.graph == "export") {
              this.exportSummary = r.data.summary
            }
            this.json_data = r.data;
            this.json_menu = r.data.menu;
            this.timestamp = r.data.timestamp;
            this.action = action;
          }
        })
        .catch((_) => {
          message.config({
            top: "10px",
            duration: 2,
            maxCount: 3,
          });
          message.error("JSON Error");
        })
        .finally((_) => {
          setTimeout(() => {
            this.first_load = false;
            this.changeGraph = false;
            this.loading = false;
          }, 100);
        });
    },
  },
  computed: {
    isStat() {
      return !this.isExport;
    },
    isExport() {
      return this.selectedParams.graph === "export";
    },
    graph() {
      return this.$route.params.graph;
    },
    year() {
      return this.selectedParams?.year;
    },
    type() {
      return this.$route.params.type;
    },
    num() {
      return this.$route.params.num;
    },
  },
  created() {
    // this.getStatData(true)
  },
  mounted() {
    setTimeout(() => {
      this.getParams();
    }, 300);
  },
};
</script>
<style media="screen">
div#graphique {
  padding: 208px 10px 0 70px;
}
div#graphique_area {
  padding: 20px;
  width: 1100px;
  height: 148px;
  margin: auto;
  position: relative;
}
div#noGrap {
  width: 500px;
  margin: 260px auto;
  text-align: center;
  font-size: 1.2em;
  color: #2a3e50;
}

div#graphLoadingBG {
  position: fixed;
  background-color: #ffffff00;
  z-index: 10;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
div#graphLoading {
  position: fixed;
  z-index: 12;
  top: 60px;
  left: 690px;
}

</style>
